import { Injectable } from '@angular/core';
import { Observable, map, catchError, tap, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { User, Role, RoleRequest } from '../models/user.models';
import { environment } from '@environments/environment';
import { PaginatedResponse } from '@app/shared/models/paginated-response';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getRoles(): Observable<Role[]> {
    return this.http
      .get<{ isSuccess: boolean; value: Role[]; error: any }>(`${this.apiUrl}/v1/Role/all`)
      .pipe(
        map((response) => response.value),
        catchError((error) => {
          console.error('Get roles error:', error);
          return throwError(() => new Error('Failed to fetch roles'));
        }),
      );
  }
  updateRole(id: number, roleData: RoleRequest): Observable<Role> {
    return this.http.put<Role>(`${this.apiUrl}/v1/Role/${id}`, roleData);
  }

  createRole(roleData: RoleRequest): Observable<Role> {
    return this.http.post<Role>(`${this.apiUrl}/v1/Role`, roleData);
  }

  deleteRole(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/v1/Role/${id}`);
  }
}
